import { doGETRequest, doPOSTRequest } from "./Api";

class WarehouseApi {

  public static async createWarehouse(warehouseData: any) {
    const relativePath = "/warehouses";
    const response = await doPOSTRequest(relativePath, warehouseData);
    return response;
  }

  public static async listAllWarehouses() {
    const relativePath = "/warehouses";
    const response = await doGETRequest(relativePath);
    return response;
  }

  public static async listAllWarehousesByStockType(stockType: any) {
    const relativePath = `/warehouses/by-stockType?stockType=${stockType}`;
    const response = await doGETRequest(relativePath);
    return response;
  }

  /*
  public static async updateWarehouse(warehouseData: any) {
    const relativePath = "/warehouses";
    const response = await doPUTRequest(relativePath, warehouseData);
    return response;
  }

  public static async deleteWarehouse(id: number) {
    const relativePath = `/warehouses/${id}`;
    const response = await doDELETERequest(relativePath);
    return response;
  }
  */
}

export default WarehouseApi;